import {
  getProductDashboardLink,
  resolveDashboardLinkKeyByPath,
} from '@/router/pageConst'
import { NavigateFunction, NavigateOptions, To, useNavigate } from 'react-router-dom'
import { useCallback } from 'react'
import useProductType from './useProductType'


function useNewNavigate() {
  const navigate: NavigateFunction = useNavigate()
  const { productType } = useProductType()
  const newNavigate = useCallback((to: To, options?: NavigateOptions) => {
    if (typeof to !== 'string') {
      navigate(to, options)
      return
    }
    const match = to.match(/^([^?#]*)(.*)$/)
    const purePath = match?.[1] || to
    const suffix = match?.[2] || ''
    const linkKey = resolveDashboardLinkKeyByPath(purePath)
    if (linkKey) {
      navigate(`${getProductDashboardLink(productType, linkKey)}${suffix}`, options)
      return
    }
    navigate(to, options)
  }, [navigate, productType])
  return newNavigate
}


export default useNewNavigate
